const brand = "MASCOTAS";
const baseUrl = "https://mascotas-5083fd69e6f3.herokuapp.com";
const baseUrlApi = "https://mascotas-5083fd69e6f3.herokuapp.com/api";

export const config = {
  brand,
  baseUrl,
  baseUrlApi,
  defaultUserImage:
    "https://static.vecteezy.com/system/resources/previews/005/544/718/non_2x/profile-icon-design-free-vector.jpg",
  imgbbApiKey: "f369e564a35464c187abaecc81d252ab",
  email: "info@mascotas.com",
  phone: "+1 (123) 456-7890",
  address: "123 Main St, City, Country",
  socialMedia: {
    facebook: "https://facebook.com/mascotas",
    twitter: "https://twitter.com/mascotas",
    instagram: "https://instagram.com/mascotas",
    linkedin: "https://linkedin.com/company/mascotas",
  },
  theme: {
    // Cambiado: logo ahora apunta directamente al archivo público
    logo: "/logo-mascotas.svg",
    brandLogo: "logo-mascotas.svg",
    colors: {
      primaryColor: "#C8AD7F",      // Marrón claro/tostado principal
      secondaryColor: "#E6D3B3",    // Beige suave/arena
      tertiaryColor: "#A67C52",     // Marrón medio/dorado
      quaternaryColor: "#F5F1E6",   // Crema cálido muy claro
      textMenuColor: "#7C5C3E",     // Marrón oscuro para texto menú
      textMenuHoverColor: "#B68F6B" // Marrón dorado para hover menú
    },
  },
  mercadopago: {
    clientId: "99922095",
    redirectUrl: baseUrl + "/mercadopago/callback",
  },
  subscription: {
    price: 9.90,
    billingCycle: "monthly",
    conversionRate: 1500,
  },
};
